import PropTypes from 'prop-types';
import React from 'react';
import Star from '../components/Star';
import { STATUS } from '../../constants/result';
import { isAnyUrlMatchesPathname } from '../utils/browserUtils';
import { PAGES_WITH_CAPTIONS } from '../../constants/url';
import AccessibilitySettingsDropdown from '../components/AccessibilitySettingsDropdown/AccessibilitySettingsDropdown';

function handleOrientationChange() {
    setTimeout(() => {
        const container = document.getElementById('header-container-inner');
        const parentContainer = document.getElementById('container');
        const parentContainerWidth = parentContainer ? parentContainer.offsetWidth : 0;
        const studentNameGradeContainer = document.getElementById('lantern-student');
        const studentNameGradeContainerWidth = studentNameGradeContainer ? studentNameGradeContainer.offsetWidth : 0;
        if (container) {
            container.style.left = `${parentContainerWidth/2 - studentNameGradeContainerWidth/2}px`;
            container.style.width = `${parentContainerWidth/2 + studentNameGradeContainerWidth/2}px`;
        }
    }, 0);
}

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            logoutButtonVisible: false,
        };

        this.onDropMenuClick = this.onDropMenuClick.bind(this);
        this.logoutButtonAction = this.logoutButtonAction.bind(this);
        this.hideLogoutButton = this.hideLogoutButton.bind(this);
        this.onTapOutsideEvent = this.onTapOutsideEvent.bind(this);
        this.handleClickOffStudentName = this.handleClickOffStudentName.bind(this);
        this.caretRender = this.caretRender.bind(this);
    }

    componentDidMount() {
        this.handleClickOffStudentName();
        if ('orientation' in window.screen) {
            window.screen.orientation.addEventListener('change', handleOrientationChange);
        } else if ('orientationchange' in window) {
            window.addEventListener('orientationchange', handleOrientationChange);
        }
        window.addEventListener('resize', handleOrientationChange);
    }

    componentDidUpdate({ shouldShowLogoutButton }) {
        this.handleClickOffStudentName();

        if (this.props.shouldShowLogoutButton !== shouldShowLogoutButton
            && !this.props.shouldShowLogoutButton) {
            this.hideLogoutButton();
        }
    }

    componentWillUnmount() {
        if ('orientation' in window.screen) {
            window.screen.orientation.removeEventListener('change', handleOrientationChange);
        } else if ('orientationchange' in window) {
            window.removeEventListener('orientationchange', handleOrientationChange);
        }
        window.removeEventListener('resize', handleOrientationChange);
    }

    onTapOutsideEvent(e) {
        if (this.state.logoutButtonVisible) {
            if (!e.target.matches('.dropmenu-trigger')) {
                this.hideLogoutButton();
            }
        }
    }

    onDropMenuClick(e) {
        e.stopPropagation();
        this.toggleLogoutButton();
    }

    getStars() {
        return this.props.playlistForRender.map((playlistItem, index) => (
            <Star
                key={`star-${playlistItem.key}`}
                index={index + 1}
                isFilled={playlistItem.status === STATUS.COMPLETED}
                withShadow={true} />
        ));
    }

    toggleLogoutButton() {
        this.setState(prevState => ({
            logoutButtonVisible: this.props.shouldShowLogoutButton
                && !prevState.logoutButtonVisible,
        }));
    }

    logoutButtonAction() {
        this.toggleLogoutButton();
        this.props.showModal();
    }

    hideLogoutButton() {
        if (this.state.logoutButtonVisible) {
            this.setState({
                logoutButtonVisible: false,
            });
        }
    }

    handleClickOffStudentName() {
        if (this.props.shouldShowLogoutButton) {
            window.addEventListener('click', this.onTapOutsideEvent);
            window.addEventListener('touchend', this.onTapOutsideEvent);
        } else {
            window.removeEventListener('click', this.onTapOutsideEvent);
            window.removeEventListener('touchend', this.onTapOutsideEvent);
        }
    }

    caretRender() {
        return this.state.logoutButtonVisible ? ' \u25B2' : ' \u25BC';
    }

    render() {
        handleOrientationChange();
        return (
            <nav className="assessment-header navbar navbar-fixed-top">
                <div id="container" className="container">
                    <div className="lantern-brand">
                        <span>mCLASS&#174;</span>
                    </div>
                    <div id="header-container-inner" className="header-container-inner">
                        <div id="lantern-student" className="lantern-student">
                            <div
                                onClick={this.onDropMenuClick}
                                className="dropmenu-trigger">
                                <div className="student-name">
                                    {`${this.props.studentName}`}
                                </div>
                                <div className="dash">-</div>
                                <div className="student-grade">{`Grade ${this.props.studentGrade}`}</div>
                                {this.props.shouldShowLogoutButton && this.caretRender()}
                            </div>
                            {this.state.logoutButtonVisible
                                && (
                                    <div
                                        className="dropmenu show"
                                        onClick={this.logoutButtonAction}>
                                        Log Out
                                    </div>
                                )}
                        </div>
                        <div className="starts-container">
                            {
                                this.props.showStars
                                    && (
                                        <div className={`header-stars stars-count-${this.props.playlistForRender.length} stars-on-0`}>
                                            {this.getStars()}
                                        </div>
                                    )
                            }
                            {
                                isAnyUrlMatchesPathname(this.props.location.pathname, PAGES_WITH_CAPTIONS) && (
                                    <AccessibilitySettingsDropdown
                                        showSettingsPopup={this.props.showSettingsPopup}
                                        isMazeLicensed={this.props.isMazeLicensed}
                                    />
                                )
                            }
                        </div>

                    </div>
                </div>
            </nav>
        );
    }
}

Header.propTypes = {
    playlistForRender: PropTypes.array,
    studentName: PropTypes.string,
    studentGrade: PropTypes.string,
    showStars: PropTypes.bool,
    shouldShowLogoutButton: PropTypes.bool,
    showModal: PropTypes.func,
    showSettingsPopup:PropTypes.func,
    location: PropTypes.object,
    isMazeLicensed: PropTypes.bool,
};

Header.defaultProps = {
    playlistForRender: [],
    studentName: '',
    studentGrade: '',
    showStars: true,
    shouldShowLogoutButton: false,
    showModal: () => { },
    showSettingsPopup: () => {},
    location: {},
    isMazeLicensed: false,
};

export default Header;
